import * as React from 'react';

import SourceEmailEditor from './Source/SourceEmailEditor';

import 'codemirror/theme/monokai.css';
import EditorSpeedSelector from '../EditorSpeedSelector';
import { Alert } from '@arco-design/web-react';
import { IconEdit, IconCode } from '@arco-design/web-react/icon';
import EasyEmailEditor from '../../../../../Editor/EasyEmail/EasyEmailEditor';
import useMediaQuery, { PHONE_QUERY } from '../../../../../utils/useMediaQuery';

// Editor modes. Exported so the parent (BroadcastMailVariantEditor) can pick the
// initial mode and read the chosen mode at save time.
export const EDITOR_EASY_EMAIL = "easy_email"; // Easy Email visual/MJML editor
export const EDITOR_CODE = "code";             // raw-HTML source (CodeMirror) fallback

export default function HtmlEditor(props) {
    const { editor, setEditor, htmlContent, setHtmlContent, editorDesign, easyEmailRef, editorHeight, confirmLink, onFlowLink } = props;

    const phone = useMediaQuery(PHONE_QUERY);

    const speedActions = [
        { icon: <IconEdit />, name: 'Visual Editor', value: EDITOR_EASY_EMAIL, select: () => { setEditor(EDITOR_EASY_EMAIL) } },
        { icon: <IconCode />, name: 'Code Editor', value: EDITOR_CODE, select: () => { setEditor(EDITOR_CODE) } },
    ];

    return (
        <div>
            <Alert
                type="info"
                content="Most recipients use email clients that support HTML (gmail, yahoo, outlook, etc). This is what they'll see."
                style={{ marginBottom: 8 }}
            />
            {phone && (
                <Alert
                    type="warning"
                    content={editorDesign && editorDesign.content
                        // The design is kept apart from the HTML. Saving from the
                        // visual editor rebuilds the HTML from it, dropping code edits.
                        ? "The visual editor needs a bigger screen, and this email was made with it. Edit it on a computer: changes in the Code Editor are lost the next time it's saved from the visual editor."
                        : "The visual editor needs a bigger screen. You can edit the code here, or open this on a computer to use it."}
                    style={{ marginBottom: 8 }}
                />
            )}
            <div>
                {
                    editor === EDITOR_EASY_EMAIL &&
                    <EasyEmailEditor
                        ref={easyEmailRef}
                        initialDesign={editorDesign}
                        confirmLink={confirmLink}
                        onFlowLink={onFlowLink}
                        // Fill the viewport (minus the app/toolbar chrome above)
                        // instead of a fixed 520px, which clipped Easy Email's
                        // 3-column layout and crammed the Configuration panel.
                        height={editorHeight || "calc(100vh - 240px)"}
                    />
                }

                {
                    editor === EDITOR_CODE && <SourceEmailEditor
                        htmlContent={htmlContent}
                        setHtmlContent={setHtmlContent}
                    />
                }
            </div>
            <EditorSpeedSelector actions={speedActions} value={editor} />
        </div>
    )

}
